<template>
    <div
        class="ppv2-flex ppv2-flex-col ppv2-justify-center ppv2-items-center"
        :style="{ gap: globalSizes.gapContainerCard, padding: globalSizes.padContainerCard }"
    >
        <HeaderStep :step="step" :sizes="sizes" />
        <div class="ppv2-flex ppv2-flex-wrap ppv2-w-full justify-content-center" :style="{ gap: globalSizes.padContainerCard }">
            <div
                v-for="exp in filteredExperiences"
                :key="exp.id"
                class="card ppv2-bg-[#060B28]"
                :style="{
                    width: cardWidth,
                    height: normalizeSize(362),
                    backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) -27.57%, #000000 137.59%),url(${exp.bg})`,
                }"
                :class="
                    !exp.authorized
                        ? 'ppv2-bg-[#7D2DBD] ppv2-opacity-50 ppv2-cursor-not-allowed ppv2-pointer-events-none ppv2-transition-all ppv2-shadow-lg'
                        : ''
                "
                @click="!exp.authorized ? () => {} : startExperience(exp)"
            >
                <div class="card-content" :style="{ padding: globalSizes.padCard }">
                    <div class="ppv2-w-full">
                        <div v-if="exp.name_subscription" class="ppv2-mb-2">
                            <span
                                class="ppv2-bg-[#7D2DBD] ppv2-text-white ppv2-px-3 ppv2-py-1 ppv2-rounded-full ppv2-text-[10px] poppinsSemiBold ppv2-flex ppv2-items-center ppv2-gap-1 ppv2-w-fit"
                            >
                                <StarIcon size="12" class="ppv2-fill-white" /> {{ $t(exp.name_subscription) }}
                            </span>
                        </div>
                        <div class="experience-title" :style="{ fontSize: globalSizes.titleExp }" v-html="exp.title"></div>
                    </div>
                    <img :src="exp.icon" alt="experience-icon" class="experience-icon" />
                    <div>
                        <div
                            class="experience-description"
                            :style="{ fontSize: globalSizes.descExp, minHeight: normalizeSizeVertical(63, true) }"
                        >
                            {{ exp.description }}
                        </div>
                        <div class="experience-link" :style="{ marginTop: normalizeSizeVertical(20, true) }">
                            <a
                                href="#"
                                @click.prevent="!exp.authorized ? () => {} : startExperience(exp)"
                                class="font-link"
                                :style="{ fontSize: globalSizes.fontLink }"
                            >
                                {{ $t('experience.step1.startUp') }} <ArrowRightIcon />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ArrowRightIcon, StarIcon } from 'vue-feather-icons'
import normalizeSize from '../../../../utils/normalizeSize'
import HeaderStep from './HeaderStep.vue'
import normalizeSizeVertical from '../../../../utils/normalizeSizeVertical'

export default {
    components: {
        ArrowRightIcon,
        HeaderStep,
        StarIcon,
    },
    props: {
        step: { type: Object, required: true },
        sizes: { type: Object, required: true },
        selected_experience: { type: Object, required: false },
        id: { type: [Number, String], default: null },
        canCreateExperience: { type: Boolean, default: false },
        canCreateForfait: { type: Boolean, default: false },
        canCreateFormule: { type: Boolean, default: false },
        canCreateAbonnement: { type: Boolean, default: false },
        planFormule: { type: Object, default: () => null },
        planForfait: { type: Object, default: () => null },
        planAbonnement: { type: Object, default: () => null },
        tenant: { type: Object, default: () => null },
    },
    data() {
        return {
            windowWidth: window.innerWidth,
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize)
    },
    methods: {
        normalizeSizeVertical,
        async startExperience(exp) {
            // Redirect to Package V3 page for "formule combiné"
            if (exp.type === 'pack') {
                window.location.href = '/back-office/v3/package/create'
                return
            }
            if (exp.type === 'abonnement') {
                window.location.href = '/back-office/v3/serie/create'
                return
            }
            this.$emit('next-step', exp)
        },
        handleResize() {
            this.windowWidth = window.innerWidth
        },
        normalizeSize,
        access_plan(user_plan_id, plan) {
            if (!plan) return false
            return user_plan_id >= plan.min_plan_level || plan.is_given_by_super_admin
        },
    },
    computed: {
        experiences() {
            return [
                {
                    id: 1,
                    title: this.$t('experience.step1.card1.title'),
                    description: this.$t('experience.step1.card1.description'),
                    icon: '/media/bo/icons/ticketExperience.png',
                    bg: '/media/bo/backgounds/bgExperience.png',
                    type: 'experience',
                    planLevel: 0,
                    authorized: true,
                },
                {
                    id: 2,
                    title: this.$t('experience.step1.card2.title'),
                    description: this.$t('experience.step1.card2.description'),
                    icon: '/media/bo/icons/ticket.png',
                    bg: '/media/bo/backgounds/bgComboExp.png',
                    type: 'pack',
                    planLevel: this.planFormule,
                    name_subscription: 'subscription.plan_required.essentiel',
                    authorized: this.access_plan(this.tenant?.plan_id, this.planFormule),
                },
                {
                    id: 3,
                    title: this.$t('experience.step1.card3.title'),
                    description: this.$t('experience.step1.card3.description'),
                    icon: '/media/bo/icons/qrCode.png',
                    bg: '/media/bo/backgounds/bgForfait.png',
                    type: 'forfait',
                    planLevel: this.planForfait,
                    name_subscription: 'subscription.plan_required.essentiel',
                    authorized: this.access_plan(this.tenant?.plan_id, this.planForfait),
                },

                {
                    id: 4,
                    title: this.$t('experience.step1.card4.title'),
                    description: this.$t('experience.step1.card4.description'),
                    icon: '/media/bo/icons/infinity.png',
                    bg: '/media/bo/backgounds/bgAbonnement.png',
                    type: 'abonnement',
                    planLevel: this.planAbonnement,
                    name_subscription: 'subscription.plan_required.premium',
                    authorized: this.access_plan(this.tenant?.plan_id, this.planAbonnement),
                },
            ]
        },
        filteredExperiences() {
            return this.experiences.filter((exp) => {
                if (exp.type === 'experience' && !this.canCreateExperience) return false
                if (exp.type === 'pack' && !this.canCreateFormule) return false
                if (exp.type === 'forfait' && !this.canCreateForfait) return false
                if (exp.type === 'abonnement' && !this.canCreateAbonnement) return false
                return true
            })
        },
        cardWidth() {
            return this.windowWidth <= 1400 ? this.normalizeSize(260) : this.normalizeSize(280)
        },

        globalSizes() {
            return {
                titleExp: this.normalizeSize(32, true),
                descExp: this.normalizeSize(13, true),
                fontLink: this.normalizeSize(17, true),
                padCard: this.normalizeSize(20, true),
                padContainerCard: this.normalizeSize(30),
                gapContainerCard: this.normalizeSize(100, true),
            }
        },
    },
}
</script>

<style scoped>
.cards-container {
    display: flex;
    justify-content: center;
    align-items: flex-start;
}

/* ---- CARD ---- */
.card {
    position: relative;
    min-width: 205px;
    min-height: 246px;
    border-radius: 18px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    transition: all 0.4s ease;
    cursor: pointer;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
}

.card:hover {
    transform: scale(1.03);
    box-shadow: 0 0 30px rgba(125, 45, 189, 0.6);
}

/* ---- CONTENT ---- */
.card-content {
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    width: 100%;
}

/* ---- TITRE ---- */
.experience-title {
    font-family: 'Poppins SemiBold', sans-serif;
    line-height: 1.2;
    color: #ffffff;
    width: 100%;
    text-align: left;
    min-height: 25%;
    /* text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;*/
}

/* ---- ICON ---- */
.experience-icon {
    width: 40px;
    height: 40px;
    margin: 0;
    color: white;
    object-fit: contain;
}

/* ---- DESCRIPTION ---- */
.experience-description {
    font-family: 'Poppins Light', sans-serif;
    color: #e0e0e0;
    text-align: left;
    line-height: 1.2;
}

.font-link {
    font-family: 'Poppins Regular', sans-serif;
    color: #ffffff;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 6px;
    transition: color 0.3s;
}

.font-link:hover {
    color: #7d2dbd;
}
</style>
